import React from 'react'
import { Link } from "react-router-dom";


const BlogDetails = () => {
  return (
    <>
      <div className="site-breadcrumb" style={{ background: 'url(assets/yog/0101.webp)' }}>
        <div className="container">
          <h2 className="breadcrumb-title">Blog Details</h2>
          <ul className="breadcrumb-menu">
            <li><Link to="/">Home</Link></li>
            <li className="active">Blog Details</li>
          </ul>
        </div>
      </div>


      <div className="blog-single py-120" style={{marginTop:"-90px"}}>
        <div className="container">
          <div className="row g-4">
            <div className="col-lg-12">
              <div className="blog-single-wrap">
                <div className="blog-single-content">
                  <div className="blog-thumb-img">
                    <img src="assets/yog/single.webp" alt="thumb" />
                  </div>
                  <div className="blog-info">
                    <div className="blog-details">
                      <h3 className="blog-details-title mb-20">Slash Your Electricity Bill: How Solar Power
                        Pays for Itself</h3>
                      <p className="mb-10" style={{textAlign:"justify"}}>
                        This summer, the temperatures are so high that you can't get by without turning on the AC or fan, leading to hefty electricity bills that can be a real shock for your pocket. In Satna, the electricity demand recently hit an all-time high due to the scorching heat, breaking all previous records. Experts predict this demand will keep rising as temperatures increase. Higher electricity demand often leads to power cuts and an irregular power supply, making the situation even worse.
                      </p>
                      <p className="mb-10" style={{textAlign:"justify"}}>
                        But Yogesh Solar Energy is here with a solution! Installing solar panels on your rooftop can help you avoid these problems. With solar panels, your rooftop becomes your power supply house. You can stay cool without worrying about high electricity bills. Plus, you won't have to deal with power cuts because you’ll have a more reliable power source. Installing a solar power plant on the roofs of your homes and housing societies, commercial spaces or industrial spaces can result in significant financial benefits.
                      </p>
                      <blockquote className="blockqoute" style={{textAlign:"justify"}}>
                        Switch to solar energy and let your rooftop save you money and keep you cool this summer!
                        <h6 className="blockqoute-author">Yogesh Solar Energy</h6>
                        <i className="fal fa-quote-right blockqoute-icon" />
                      </blockquote>
                      <div className="row">
                        <div className="col-md-6 mb-20">
                          <img src="assets/img/blog/01.jpg" alt />
                        </div>
                        <div className="col-md-6 mb-20">
                          <img src="assets/yog/How to Choose.webp" alt />
                        </div>
                      </div>
                      <hr />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="col-lg-4">
              <aside className="blog-sidebar">
                
                <div className="widget social">
                  <h5 className="widget-title">Follow Us</h5>
                  <div className="social-link">
                    <a to="#"><i className="fab fa-facebook-f" /></a>
                    <a to="#"><i className="fab fa-x-twitter" /></a>
                    <a to="#"><i className="fab fa-dribbble" /></a>
                    <a to="#"><i className="fab fa-whatsapp" /></a>
                    <a to="#"><i className="fab fa-youtube" /></a>
                  </div>
                </div>
              </aside>
            </div> */}
          </div>
        </div>
      </div>


    </>
  )
}

export default BlogDetails